import type { SchemaOperation, Patches } from '../types'
import { SchemaOperationType } from '../types'
import { validateCollectionId } from '../validation/validators'
import { deleteFieldPermanently } from './fields'
import { enablePlugin, removeDisplayField } from './schemaProperties'

export const createSchema = (
  collectionId: string,
  ...patches: Patches
): SchemaOperation => {
  validateCollectionId(collectionId)
  return {
    collectionId,
    patches,
    type: SchemaOperationType.CREATE,
  }
}

export const createSinglesSchema = (
  collectionId: string,
  ...patches: Patches
): SchemaOperation => {
  validateCollectionId(collectionId)

  const singleItemCollectionPatches: Patches = [
    [
      enablePlugin('singleItem', {
        singleItemId: 'SINGLE_ITEM_ID',
      }),
      deleteFieldPermanently('title'),
      removeDisplayField(),
    ],
  ]

  return {
    collectionId,
    patches: singleItemCollectionPatches.concat(patches),
    type: SchemaOperationType.CREATE,
  }
}

export const updateSchema = (
  collectionId: string,
  ...patches: Patches
): SchemaOperation => {
  validateCollectionId(collectionId)
  return {
    collectionId,
    patches,
    type: SchemaOperationType.UPDATE,
  }
}

export const removeSchema = (collectionId: string): SchemaOperation => {
  validateCollectionId(collectionId)
  return {
    collectionId,
    type: SchemaOperationType.REMOVE,
  }
}

export const restoreSchema = (collectionId: string): SchemaOperation => {
  validateCollectionId(collectionId)
  return {
    collectionId,
    type: SchemaOperationType.RESTORE,
  }
}
